import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import { Icon } from "@iconify/react";
import {
  createNewTableColumns,
  getDefaultCheckedMemberTableColumns,
  memberTableColumns,
  moveItemInArray,
} from "../../../utils/memberUtils";
import { Button } from "@mui/material";
import Iconify from "../../../components/iconify";
import { useUpdateMemberTableSettingsMutation } from "../../../features/users/usersApiSlice";

export default function MemberSidebarTableOptions({
  tableColumns,
  handleChangeTableColumns,
}) {
  const [checked, setChecked] = React.useState(
    getDefaultCheckedMemberTableColumns(tableColumns)
  );
  const [columns, setColumns] = React.useState(
    tableColumns.map((c) => c.label)
  );
  const [state, setState] = React.useState(null);

  const [updateMemberTableSettings] = useUpdateMemberTableSettingsMutation();

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleChangeColumnPosition = (index, move) => {
    let newColumns = moveItemInArray(columns, index, move);
    setColumns(newColumns);
  };

  const onChangeColumns = async (option) => {
    setState("loading");
    if (option === "reset") {
      // Reset table columns to default
      setTimeout(() => {
        handleChangeTableColumns(memberTableColumns);
        setChecked(getDefaultCheckedMemberTableColumns(memberTableColumns));
        setColumns(memberTableColumns.map((c) => c.label));
        setState("success");
      }, 500);
      return null;
    }
    if (option === "save") {
      // Save option to user settings
      console.log("option :>> ", option);
      try {
        let result = await updateMemberTableSettings({
          memberTableSettings: { defaultColumns: checked },
        }).unwrap();
        console.log("result :>> ", result);
      } catch (error) {
        console.error("Error saving member table settings:", error);
        setState("error");
        return;
      } finally {
        let newTableColumns = createNewTableColumns(columns, checked);
        setTimeout(() => {
          handleChangeTableColumns(newTableColumns);
          setState("success_table");
        }, 1500);
        return null;
      }
    }
    // Create array from correct sorted array and set show to true according to checked array
    let newTableColumns = createNewTableColumns(columns, checked);
    setTimeout(() => {
      handleChangeTableColumns(newTableColumns);
      setState("success_table");
    }, 1500);
  };

  console.log("state :>> ", state);
  console.log("checked :>> ", checked);
  console.log("memberTableColumns :>> ", memberTableColumns);

  return (
    <div>
      <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
        {columns.map((value, index) => {
          const labelId = `checkbox-list-label-${value}`;

          return (
            <ListItem
              disablePadding
              key={value}
              secondaryAction={
                <div>
                  <IconButton
                    onClick={() => handleChangeColumnPosition(index, "up")}
                    edge="start"
                    aria-label="move-up"
                  >
                    <Icon icon="fa-solid:arrow-up" width="18" height="18" />
                  </IconButton>
                  <IconButton
                    onClick={() => handleChangeColumnPosition(index, "down")}
                    edge="end"
                    aria-label="move-down"
                  >
                    <Icon icon="fa-solid:arrow-down" width="18" height="18" />
                  </IconButton>
                </div>
              }
            >
              <ListItemButton
                role={undefined}
                onClick={handleToggle(value)}
                dense
                sx={{ p: 0 }}
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={checked.indexOf(value) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={`${value}`} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Button
        disableRipple
        color={state === "success_table" ? "success" : "primary"}
        disabled={state === "loading"}
        variant="contained"
        fullWidth
        endIcon={
          state === "success_table" ? (
            <Iconify icon="icon-park-twotone:success" />
          ) : (
            <Iconify icon="mdi:settings" />
          )
        }
        onClick={onChangeColumns}
      >
        Übernehmen
      </Button>
      <Button
        sx={{ mt: 2 }}
        disableRipple
        color="inherit"
        disabled={state === "loading"}
        variant="contained"
        fullWidth
        endIcon={<Iconify icon="material-symbols:reset-wrench" />}
        onClick={() => onChangeColumns("reset")}
      >
        Auf standard zurücksetzen
      </Button>
      <Button
        sx={{ mt: 2 }}
        disableRipple
        color="secondary"
        disabled={state === "loading"}
        variant="contained"
        fullWidth
        endIcon={<Iconify icon="mdi:settings" />}
        onClick={() => onChangeColumns("save")}
      >
        Als Standard speichern
      </Button>
    </div>
  );
}
